import React, { useEffect, useRef } from 'react';
import Raphael from 'raphael';
import usMap from './us-map-svg';
import marker1 from "../../images/map-marker.png";
import marker2 from "../../images/map-marker-2.png";

const USMap = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    const container = mapRef.current;
    if (!container) return;

    const drawMap = () => {
      if (!container.parentElement) return;
      const baseW = 1000, baseH = 900;
      const parentW = container.parentElement.offsetWidth;
      if (parentW === 0) return;

      const scale = parentW / baseW;
      container.innerHTML = '';
      Object.assign(container.style, {
        width: `${baseW}px`,
        height: `${baseH}px`,
        transform: `scale(${scale})`,
        transformOrigin: 'top left'
      });

      const R = Raphael(container, baseW, baseH);
      const attr = {
        fill: '#d3d3d3',
        stroke: '#fff',
        'stroke-opacity': '1',
        'stroke-linejoin': 'round',
        'stroke-miterlimit': '4',
        'stroke-width': '0.75',
        'stroke-dasharray': 'none'
      };

      // draw states
      for (const st in usMap) {
        const sAttr = { ...attr };
        if (['ok', 'ky', 'ga', 'or', 'ca', 'az', 'tx', 'il', 'oh', 'nv'].includes(st)) {
          sAttr.fill = '#fa4d09';
        }
        R.path(usMap[st]).attr(sAttr);
      }

      // markers
      const markers = {
        Portland: { x: 75, y: 110 },
        Fresno: { x: 80, y: 300 },
        Georgia: { x: 710, y: 400 },
        Reno: { x: 100, y: 230 },
        Phoenix: { x: 200, y: 380 },
        Odessa: { x: 360, y: 410 },
        Houston: { x: 520, y: 460 },
        Dallas: { x: 480, y: 430 },
        Oklahoma: { x: 460, y: 360 },
        Itasca: { x: 615, y: 215 },
        Louisville: { x: 660, y: 290 },
        Cleveland: { x: 710, y: 210 },
      };
      const imgs = { Portland: marker1, Oklahoma: marker2, Georgia: marker2, Louisville: marker2, default: marker1 };

      for (const city in markers) {
        const { x, y } = markers[city];
        const icon = imgs[city] || imgs.default;
        const marker = R.image(icon, x - 12, y - 20, 24, 24)
          .attr({ cursor: 'pointer', title: city });

        (city => {
          marker.click(() => {
            document.querySelectorAll('.map_location').forEach(el => el.style.border = '');
            const target = document.querySelector(`.${city}`);
            if (target) {
              target.style.border = '2px solid #fa4d09';
              target.scrollIntoView({ behavior: 'smooth' });
            }
            if (['Oklahoma', 'Georgia', 'Louisville'].includes(city)) {
              const existing = document.querySelector('.city-label');
              if (existing) existing.remove();
              const details = {
                Oklahoma: `
                  <strong>OKLAHOMA CITY, OK</strong><br/>
                  Techtop Industries Inc.<br/>
                  8417 SW 23rd PL<br/>
                  Oklahoma City, OK 73128<br/>
                  Phone: 678-436-5515<br/>
                  <a href="mailto:Okc-orders@techtopind.com">Okc-orders@techtopind.com</a>
                `,
                Georgia: `
                  <strong>GEORGIA (HEADQUARTERS)</strong><br/>
                  Techtop Industries Inc.<br/>
                  2815 Colonnades Court<br/>
                  Norcross, GA 30071<br/>
                  Phone: 678-436-5540<br/>
                  Fax: 866-204-1498<br/>
                  <a href="mailto:orders@techtopind.com">orders@techtopind.com</a>
                `,
                Louisville: `
                  <strong>LOUISVILLE, KY</strong><br/>
                  Techtop Industries, Inc.<br/>
                  260 Park Loop Rd<br/>
                  Shepherdsville, KY 40165<br/>
                  Phone: 678-248-5320<br/>
                  <a href="mailto:lvl-orders@techtopind.com">lvl-orders@techtopind.com</a>
                `
              };
              const label = document.createElement('div');
              label.className = 'city-label';
              label.innerHTML = details[city];
              Object.assign(label.style, {
                position: 'absolute',
                backgroundColor: '#125d67',
                color: '#fff',
                border: '1px solid #ccc',
                padding: '10px',
                borderRadius: '5px',
                zIndex: '1000',
                maxWidth: '300px',
                left: `${x + 30}px`,
                top: `${y - 10}px`
              });
              container.appendChild(label);
              const onOutside = e => {
                if (!label.contains(e.target) && !marker.node.contains(e.target)) {
                  label.remove();
                  document.removeEventListener('click', onOutside);
                }
              };
              setTimeout(() => document.addEventListener('click', onOutside), 0);
            }
          });
        })(city);
      }
    };

    // observe parent size changes
    const observer = new ResizeObserver(drawMap);
    observer.observe(container.parentElement);

    // cleanup
    return () => observer.disconnect();
  }, []);

  return (
    <div style={{
      width: '100%',
      height: '550px',
      overflow: 'hidden'
    }}>
      <div
        id="us_map"
        ref={mapRef}
        style={{
          position: 'relative',
          willChange: 'transform'
        }}
      />
    </div>
  );
};

export default USMap;